module.exports = __webpack_public_path__ + "static/media/notes.fe43b924.svg";